var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRenameInactiveBlueIcon = function SvgRenameInactiveBlueIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    d: "m17.362 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L11.082 16.07a4.5 4.5 0 0 1-1.897 1.13L6.5 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897zm0 0L20 7.125M18.5 14v4.75A2.25 2.25 0 0 1 16.25 21H5.75a2.25 2.25 0 0 1-2.25-2.25V8.25A2.25 2.25 0 0 1 5.75 6h4.75"
  })));
};
export { SvgRenameInactiveBlueIcon as ReactComponent };
export default __webpack_public_path__ + "ed5dc93985ebaff011362952c49facaa.svg";